import { PermissionEnum } from "utils/enums";
import { isJustSuperAdmin } from "utils";
import { ROUTES } from "constants/routes";

export const SUPER_ADMIN_ONLY = "super_admin_only" as const;

export const MANDATORY_PERMISSION_SLUG = "dashboard";

export type RouteAccess = PermissionEnum | typeof SUPER_ADMIN_ONLY;

export const ROUTE_ACCESS: Record<string, RouteAccess> = {
  [ROUTES.USERS.path]: PermissionEnum.manage_users,
  [ROUTES.TRANSACTIONS.path]: PermissionEnum.deposit_table,
  [ROUTES.DEPOSITS.path]: PermissionEnum.deposit_table,
  [ROUTES.TRANSFERS.path]: PermissionEnum.transfer_table,
  [ROUTES.BAMBOO_TRANSFERS.path]: SUPER_ADMIN_ONLY,
  [ROUTES.EXCHANGE_RATES.path]: PermissionEnum.exchange_rate,
  [ROUTES.CURRENCIES.path]: PermissionEnum.currencies,
  [ROUTES.BENEFICIARIES.path]: PermissionEnum.beneficiaries,
  [ROUTES.FLAGGED_USERS.path]: PermissionEnum.sanctions_table,
  [ROUTES.CHARITY.path]: PermissionEnum.charity_table,
  [ROUTES.VIEW_DONORS.path]: PermissionEnum.charity_table,
  [ROUTES.AUDIT_TRAIL.path]: PermissionEnum.audit_trail,
  [ROUTES.MARKETING.path]: PermissionEnum.marketing,
  [ROUTES.MARKETING_OVERVIEW.path]: PermissionEnum.marketing,
  [ROUTES.PARTNERS.path]: PermissionEnum.marketing,
  [ROUTES.ONBOARD_PARTNER.path]: PermissionEnum.marketing,
  [ROUTES.PARTNER_DETAILS.path]: PermissionEnum.marketing,
  [ROUTES.VOUCHERS.path]: PermissionEnum.marketing,
  [ROUTES.ISSUE_VOUCHERS.path]: PermissionEnum.marketing,
  [ROUTES.VOUCHER_BATCH_DETAILS.path]: PermissionEnum.marketing,
  [ROUTES.REDEMPTIONS.path]: PermissionEnum.marketing,
  [ROUTES.ADMIN_USERS.path]: SUPER_ADMIN_ONLY,
  [ROUTES.FEATURE_FLAGS.path]: SUPER_ADMIN_ONLY,
};

export const getPermissionSlugs = (accountDetails: IAccountDetails): string[] =>
  accountDetails?.admin?.permissions?.map(
    (permission: any) => permission?.slug
  );

export const hasRouteAccess = (accountDetails: IAccountDetails | null, access?: RouteAccess) => {
  if (!accountDetails) return false;
  if (!access) return true;

  if (isJustSuperAdmin(accountDetails.admin.role)) return true;
  if (access === SUPER_ADMIN_ONLY) return false;
  return getPermissionSlugs(accountDetails).includes(access);

};
